import React, { useEffect, useState } from 'react';
import { Link } from 'react-scroll';
import { useTranslation } from 'react-i18next';
import desktopBg from './hero-desktop.jpg';
import mobileBg from './hero-mobile.jpg';
import './HeroSection.css';

const HeroSection = () => {
  const { t } = useTranslation();
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1080);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 1080);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const backgroundImage = isDesktop ? desktopBg : mobileBg;

  return (
    <section
      className="hero-section"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        height: '100vh',
      }}
    >
      <div className="hero-overlay">
        <div className="hero-content">
          <h1>{t('hero.title')}</h1>
          <p>{t('hero.subtitle')}</p>
          <Link to="menu" smooth={true} duration={600} offset={-80}>
            <button className="hero-button">{t('hero.cta')}</button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
